export default "__VITE_ASSET__iMCwnwVy__"